import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../media/Logos/logo-horizontal.png';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../scss/Elements/_footer.scss';
import '../scss/Elements/_login.scss';
import {
  Button,
  CircularProgress,
  FilledInput,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
} from '@mui/material';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { GlobalVariables } from '../globalVar';
import { Helmet } from 'react-helmet';
import { fetchUserPermissions } from '../hooks/userPermissions';
import { getToast } from '../utils/toastConfig';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPW] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    localStorage.removeItem('token');
  }, []);

  async function logUser(event) {
    event.preventDefault();
    setIsLoading(true);
    try {
      console.log('URL:', GlobalVariables.getURL());
      const response = await axios.post(`${GlobalVariables.getURL()}login`, {
        email: email,
        password: password,
      });
      localStorage.setItem('token', response.data.accessToken);
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('username', response.data.user.name);
      localStorage.setItem('first_surname', response.data.user.last_name);
      localStorage.setItem('userIdForPerm', response.data.user.id);
      localStorage.setItem('userIdForDVisits', response.data.user.id);
      localStorage.setItem('currUserLogged', response.data.user.id);
      localStorage.setItem('currUserEmail', response.data.user.email);
      localStorage.setItem('currUserRol', response.data.user.roles_id);
      await fetchUserPermissions();

      getToast({ status: 'success', title: 'Login exitoso. Bienvenido!' });
      setTimeout(() => {
        navigate('/dashboard');
        window.location.reload();
      }, 2000);
    } catch (error) {
      getToast({
        status: 'error',
        title:
          'Los datos ingresados no corresponden a un usuario registrado. Vuelve a intentarlo.',
      });
      console.log(error);
    }
    setIsLoading(false);
  }

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div id='login-page'>
      <Helmet>
        <title>DABI Web</title>
      </Helmet>
      <ToastContainer />
      <div className='container'>
        <div className='form-container login-container'>
          <form id='login-form' onSubmit={logUser}>
            <img src={logo} alt='dabi-logo' id='logo' />
            <FormControl sx={{ m: 1, width: '100%' }} variant='filled'>
              <InputLabel className='login-label'>E-mail</InputLabel>
              <FilledInput
                className='login-input'
                type='email'
                size='normal'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
              />
            </FormControl>
            <FormControl sx={{ m: 1, width: '100%' }} variant='filled'>
              <InputLabel className='login-label'>Contraseña</InputLabel>
              <FilledInput
                className='login-input'
                type={showPassword ? 'text' : 'password'}
                size='normal'
                value={password}
                onChange={(e) => setPW(e.target.value)}
                disabled={isLoading}
                endAdornment={
                  <InputAdornment position='end'>
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge='end'
                    >
                      {showPassword ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <a href='/recovery'>¿Olvidaste tu contraseña?</a>
            <Button
              form='login-form'
              type='submit'
              id='login-button'
              disabled={isLoading}
              variant='contained'
              color={isLoading ? 'secondary' : 'primary'}
              sx={{
                opacity: isLoading ? 0.85 : 1,
              }}
            >
              {!isLoading ? (
                'Iniciar sesión'
              ) : (
                <CircularProgress size={24} color='inherit' />
              )}
            </Button>
          </form>
        </div>
        <div className='overlay-container'>
          <div className='overlay'>
            <div className='overlay-panel overlay-right'>
              <h1 id='overlay-primary-text'>Hola, Bienvenido</h1>
              <p id='overlay-initialp'>Optimizamos tus operaciones</p>
              <p id='overlay-primaryp'>
                Generamos ahorros, facilitando la toma de decisiones para tus
                servicios en campo.
              </p>
              <button id='overlay-button'>
                <a href='https://www.dabi.io' target='_blank' rel='noreferrer'>
                  más información
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
      <footer className='loginFooter'>
        <span>Design by DABI</span>
      </footer>
    </div>
  );
};
export default Login;
